<template>
  <div class="bet_limitation">

    <div class="row">
      <div class="col-12">
        <!--START - User List -->
        <div class="element-wrapper">
          <h6 class="element-header capitalize">
            {{ t.max_stake_per_bet_slip }}
          </h6>
          <div class="element-box">
            <generalForm :uid="uid" />
          </div>
        </div>
      </div>
      <div class="col-sm-12 col-xxl-6">
        <!--START - User List -->
        <div class="element-wrapper">
          <h6 class="element-header capitalize">
            {{ t.max_earnings_per_bet_slip }}
          </h6>
          <div class="element-box">
            <MaxEarningsForm :uid="uid" />
          </div>
        </div>
      </div>
      <div class="col-sm-12 col-xxl-6">
        <!--START - User List -->
        <div class="element-wrapper">
          <h6 class="element-header capitalize">
            {{ t.max_stake_per_bet_slip }}
          </h6>
          <div class="element-box">
            <MaxStakeForm :uid="uid" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    import generalForm from '@/components/configuration/form/betSlipLimitations'
    import MaxStakeForm from '@/components/configuration/form/betSlipMaxStake'
    import MaxEarningsForm from '@/components/configuration/form/betSlipMaxEarnings'
    export default {
        name: 'betSlipLimiForm',
        components: {MaxStakeForm, MaxEarningsForm, generalForm},
        props: {
            uid:{
                default: 0,
            }
        },
        data () {
            return {
                t: this.$root.t
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .bet_limitation #form #form {
    padding-top: 20px;
    height: 600px;
    overflow: auto;
  }
</style>



// WEBPACK FOOTER //
// src/components/user/widget/BetLimitForm.vue